import { api } from "./api"
export const postAnuncio = (situation: any) => api.post(`Anuncio/incluir/`, situation);

export const getTodosAnuncios = async () => {
  try {
    const response = await api.get(`Anuncio/select`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAnuncios = async (numeroPagina: string) => {
  try {
    const response = await api.get(`Anuncio/buscartodos/${numeroPagina}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAnuncio = async (cdAnuncio: string) => {
  try {
    const response = await api.get(`Anuncio/buscar/${cdAnuncio}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const putAnuncio = (anuncio: any) => api.put(`Anuncio/alterar/`, anuncio);

export const putDesativarAnuncio = (anuncio: any) => api.put(`Anuncio/desativar`, anuncio);

export const deleteAnuncio = (data: any) =>
  api.delete(`Anuncio/excluir`, { data });

